import { Component, type ErrorInfo, type ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { surfaceForPath, trackClientEvent } from './client-events'

export function ClientRouteObserver(): null {
  const { pathname } = useLocation()
  useEffect(() => {
    void trackClientEvent({
      eventKind: 'page',
      surface: surfaceForPath(pathname),
      outcome: 'visible',
      code: 'route_visible',
    })
  }, [pathname])
  return null
}

interface BoundaryProps { children: ReactNode }
interface BoundaryState { failed: boolean }

export class ClientErrorBoundary extends Component<BoundaryProps, BoundaryState> {
  state: BoundaryState = { failed: false }

  static getDerivedStateFromError(): BoundaryState {
    return { failed: true }
  }

  componentDidCatch(_error: Error, _info: ErrorInfo): void {
    void trackClientEvent({
      eventKind: 'error',
      surface: 'app',
      outcome: 'failure',
      code: 'render_boundary',
    })
  }

  render(): ReactNode {
    if (!this.state.failed) return this.props.children
    return (
      <section className="mx-auto flex min-h-[55vh] max-w-md flex-col items-center justify-center px-6 text-center">
        <h1 className="text-xl font-bold text-slate-900">Questa schermata non si è caricata</h1>
        <p className="mt-2 text-sm text-slate-600">I tuoi progressi restano al sicuro. Ricarica e riprova.</p>
        <button
          type="button"
          className="mt-5 rounded-xl bg-violet-700 px-5 py-3 font-semibold text-white"
          onClick={() => window.location.reload()}
        >
          Ricarica
        </button>
      </section>
    )
  }
}
